/* Jubi Size Helper — 3 taps to a size recommendation.
   Room → room-specific layout question → coverage preference → size,
   with links into the matching size collection and the custom path.
   All logic client-side; the size ladder mirrors the store's collections. */
(function () {
  'use strict';

  var ROOMS = {
    living: {
      question: 'How does your seating sit?',
      options: [
        { label: 'Sofa + chairs around a table', size: '8x10', why: 'the front legs of every seat rest on the rug and the table sits fully on it — the classic living room anchor' },
        { label: 'Sectional', size: '9x12', why: 'a sectional wants the rug to reach past its full length, chaise included' },
        { label: 'Compact space', size: '6x9', why: 'it anchors the seating without crowding the walls of a smaller room' }
      ]
    },
    bedroom: {
      question: 'What size is the bed?',
      options: [
        { label: 'King or Cal King', size: '9x12', why: 'it gives a king bed a soft landing on three sides' },
        { label: 'Queen', size: '8x10', why: 'it extends past a queen on three sides — bare feet never miss' },
        { label: 'Full or Twin', size: '6x9', why: 'it frames a smaller bed without swallowing the room' }
      ]
    },
    dining: {
      question: 'How many does the table seat?',
      options: [
        { label: 'Up to 6', size: '8x10', why: 'chairs stay on the rug even when pulled out from a six-seat table' },
        { label: '6 to 8', size: '9x12', why: 'a longer table needs the extra reach so pulled-out chairs never catch the edge' },
        { label: 'More, or extendable', size: '10x14', why: 'a grand or extendable table needs a rug that keeps every chair aboard at full length' }
      ]
    },
    entry: {
      question: 'What is the space?',
      options: [
        { label: 'Hallway', size: 'runner', why: 'a runner leaves a few inches of floor showing on each side — and ours come in custom lengths' },
        { label: 'Entry landing', size: '4x6', why: 'it fills the landing with room for the door to swing clear' },
        { label: 'Grand entry', size: '6x9', why: 'a larger entry can carry a full rug moment as the first impression' }
      ]
    },
    office: {
      question: 'What is the setup?',
      options: [
        { label: 'Desk + chair', size: '6x9', why: 'the chair stays on the rug even fully rolled back' },
        { label: 'Desk + a seating area', size: '8x10', why: 'it holds the desk zone and the seating in one composed field' }
      ]
    }
  };

  var CHAIN = ['4x6', '5x7', '6x9', '8x10', '9x12', '10x14'];
  var PRETTY = { '4x6': '4×6', '5x7': '5×7', '6x9': '6×9', '8x10': '8×10', '9x12': '9×12', '10x14': '10×14', 'runner': 'A runner', 'oversized': 'Oversized' };
  var HANDLE = { '4x6': '4x6-rugs', '5x7': '5x7-rugs', '6x9': '6x9-rugs', '8x10': '8x10-rugs', '9x12': '9x12-rugs', '10x14': '10x14-rugs', 'runner': 'runner-rugs', 'oversized': 'oversized-rugs' };

  function shiftSize(size, delta) {
    if (size === 'runner') return size;
    var i = CHAIN.indexOf(size);
    if (i === -1) return size;
    var j = i + delta;
    if (j < 0) j = 0;
    if (j >= CHAIN.length) return 'oversized';
    return CHAIN[j];
  }

  function init(root) {
    if (root.dataset.jshInit) return;
    root.dataset.jshInit = 'true';

    var steps = Array.prototype.slice.call(root.querySelectorAll('.jsh__step'));
    var result = root.querySelector('.jsh__result');
    var q2Question = root.querySelector('[data-jsh-q2-question]');
    var q2Chips = root.querySelector('[data-jsh-q2-chips]');
    var resultSize = root.querySelector('[data-jsh-size]');
    var resultWhy = root.querySelector('[data-jsh-why]');
    var shopLink = root.querySelector('[data-jsh-shop]');

    var state = { room: null, base: null, why: '', shifted: 0 };

    function show(index) {
      steps.forEach(function (s, i) { s.classList.toggle('is-active', i === index); });
      if (result) result.classList.remove('is-active');
      root.classList.remove('jsh--answered');
      var q = steps[index] && steps[index].querySelector('.jsh__question');
      if (q) q.focus();
    }

    function buildQ2(roomKey) {
      var room = ROOMS[roomKey];
      if (!room || !q2Question || !q2Chips) return;
      q2Question.textContent = room.question;
      q2Chips.innerHTML = '';
      room.options.forEach(function (opt) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'jsh__chip';
        btn.textContent = opt.label;
        btn.addEventListener('click', function () {
          q2Chips.querySelectorAll('.jsh__chip').forEach(function (c) { c.classList.remove('is-selected'); });
          btn.classList.add('is-selected');
          state.base = opt.size;
          state.why = opt.why;
          show(2);
        });
        q2Chips.appendChild(btn);
      });
    }

    function renderResult() {
      var size = shiftSize(state.base, state.shifted);
      var pretty = PRETTY[size] || size;
      if (resultSize) {
        resultSize.textContent = size === 'runner' ? 'A runner' : 'Your size: ' + pretty;
      }
      if (resultWhy) {
        var note = '';
        if (state.shifted > 0 && size !== state.base) note = ' Sized up one step for the anchored, everything-on look.';
        if (state.shifted < 0 && size !== state.base) note = ' Sized down one step to keep more floor in view.';
        resultWhy.textContent = 'Because ' + state.why + '.' + note;
      }
      if (shopLink) {
        /* Solid button — no arrow, per the arrow policy */
        shopLink.textContent = size === 'runner' ? 'Shop Runner Rugs' : 'Shop ' + pretty + ' Rugs';
        shopLink.href = '/collections/' + (HANDLE[size] || 'rugs');
      }
      steps.forEach(function (s) { s.classList.remove('is-active'); });
      root.classList.add('jsh--answered');
      if (result) {
        result.classList.add('is-active');
        var heading = result.querySelector('.jsh__result-size');
        if (heading) heading.focus();
      }
    }

    root.querySelectorAll('[data-jsh-room]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        root.querySelectorAll('[data-jsh-room]').forEach(function (c) { c.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        state.room = btn.getAttribute('data-jsh-room');
        buildQ2(state.room);
        show(1);
      });
    });

    root.querySelectorAll('[data-jsh-coverage]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        root.querySelectorAll('[data-jsh-coverage]').forEach(function (c) { c.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        state.shifted = parseInt(btn.getAttribute('data-jsh-coverage'), 10) || 0;
        renderResult();
      });
    });

    root.querySelectorAll('[data-jsh-back]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var to = parseInt(btn.getAttribute('data-jsh-back'), 10) || 0;
        show(to);
      });
    });

    var restart = root.querySelector('[data-jsh-restart]');
    if (restart) {
      restart.addEventListener('click', function () {
        state = { room: null, base: null, why: '', shifted: 0 };
        root.querySelectorAll('.jsh__chip.is-selected').forEach(function (c) { c.classList.remove('is-selected'); });
        show(0);
      });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-size-helper]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var el = event.target.querySelector('[data-size-helper]');
    if (el) init(el);
  });
})();
